<template>
<b-container style="max-width: 1200px !important">
<b-row>
<b-col cols="12">
    <b-row class="justify-content-center marginalbotsm">
        <b-col cols="auto">
            <b-button @click="activePlugin = 'noDRM'" :variant="(activePlugin === 'noDRM') ? 'greenw':'msstreamblue'">{{$ml.get('examplenodrm')}}</b-button>
            &nbsp;
            <b-button @click="activePlugin = 'withDRM'" :variant="(activePlugin !== 'noDRM') ? 'greenw':'msstreamblue'" >{{$ml.get('exampledrm')}}</b-button>
        </b-col>
    </b-row>
    <!--
    <b-row class="justify-content-around align-items-center">
        <b-col cols="5" sm="4" md="3">
            <b-img fluid-grow :src="require('@/assets/logo_Q_Plugin.svg')">
                <h2>Plug-In</h2>
            </b-img>
        </b-col>
        <b-col cols="5" sm="4" md="3">
            <b-img fluid :src="require('@/assets/external_logo/dashjs.png')">
                <h2>Dash.js</h2>
            </b-img>
        </b-col> 
    </b-row>
    -->
    <b-row class="mt-2">
    <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using rxPlayer and integrating **QUANTEEC** without DRM.
```html
&lt;head>
    &lt;script src="https://cdn.jsdelivr.net/npm/rx-player">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-rxplayer.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>

&lt;body>
    &lt;video id="videoplayer" width="854" height="480" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.mpd";

            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{streamKey}}", 
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };

            var rxConfig = {
                url: videoSource,
                transport: "dash",
                autoPlay: true
            }

            const rxPlayer = new RxPlayer({
                videoElement: document.getElementById("videoplayer")
            });

            // 3-Link QUANTEEC to rxPlayer right *after* the creation of the rxPlayer instance
            var quanteecPlayer = new Quanteec(configQuanteec, rxPlayer);

            rxPlayer.loadVideo(rxConfig);
        });
    &lt;/script>
&lt;body>
```
    </vue-markdown>

    <vue-markdown :show="activePlugin === 'withDRM'" style="overflow: auto;" class="col-7" :style="(activePlugin === 'noDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using rxPlayer and integrating **QUANTEEC** with DRM.  Documentation can be found [here](https://developers.canal-plus.com/rx-player/doc/Getting_Started/Tutorials/Content_with_DRM.html).
```html
&lt;head>
    &lt;script src="https://cdn.jsdelivr.net/npm/rx-player">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-rxplayer.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>

&lt;body>
    &lt;video id="videoplayer" width="854" height="480" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.mpd";

            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{streamKey}}", 
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };

            var rxConfig = {
                url: videoSource,
                transport: "dash",
                autoPlay: true,
                  keySystems: [
                    {
                    type: "com.widevine.alpha",
                    // ...
                    },
                    {
                    type: "com.microsoft.playready",
                    // ...
                    },
                ]
            }

            const rxPlayer = new RxPlayer({
                videoElement: document.getElementById("videoplayer")
            });

            // 3-Link QUANTEEC to rxPlayer right *after* the creation of the rxPlayer instance
            var quanteecPlayer = new Quanteec(configQuanteec, rxPlayer);

            rxPlayer.loadVideo(rxConfig);
        });
    &lt;/script>
&lt;body>
```
    </vue-markdown>

    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
    </b-row>
</b-col>
</b-row>
</b-container>
</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'RxPlayer',
  data: function() {
    return {
     activePlugin:"noDRM",     
    }
  },
  props: [
      "streamKey"
  ],
  components: {
      VueMarkdown,
      ConfigDoc
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
      onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>